module.exports = __webpack_public_path__ + "static/laura-0b727d13278584d1ef7f48b84b84c7f6.jpg";